<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="input-group">
                    <input type="text" class="form-control text-center text-big" placeholder="cerca per numero seriale o matricola" [(ngModel)]="search_text" (keyup.enter)="search()">
                    <div class="input-group-append">
                        <button type="button" class="btn" (click)="search()"><i class="fa fa-search"></i></button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
<div class="row mt-1">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
            
            <div class="alert alert-info" *ngIf="list.length==0">
                Nessun seriale ricercato!
            </div>

            <table class="table table-sm table-stripped" *ngIf="list.length>0">
                <thead>
                    <th>ID</th>
                    <th>SN</th>
                    <th>Prodotto</th>
                    <th>Ubicazione</th>
                    <th>Contratto</th>
                    <th></th>
                </thead>
                <tbody>
                    <tr *ngFor="let record of list;let i=index">
                        
                        <td>{{record.id}}</td>
                        <td>{{record.sn}}</td>
                        <td>
                            
                            
                            <small class="text-info"><i class="{{record.icon}}"></i> {{record.category}}</small><br/>
                            <span class="pointer" ><span><b>{{record.brand}}</b> {{record.model}}</span></span><br/>
                                      
                            
                        </td>
                        <td>
                            <ng-container *ngIf="true">
                                <i class="fas fa-store-alt pointer"></i>
                                <span class="ml-1 text-truncate w-100" [class.trashed]="record.shopstatus==2">{{record.shopname}}
                                    <div *ngIf="record.shopstatus==2" class="badge badge-warning"><i class="fas fa-exclamation-triangle"></i>&nbsp;cestinato</div>
                                </span>
                                <span *ngIf="record.shoptypeparams!='default'"><small><i>&nbsp;({{record.shoptypename}})</i></small></span>
                                <br/>
                                <ng-container *ngIf="record.addressname">
                                    <small [class.trashed]="record.addressstatus==2">
                                        <i class="fa fa-user mx-1"></i>&nbsp;{{record.addressname}} / {{record.addressmaincontact}}
                                        <div *ngIf="record.addressstatus==2" class="badge badge-warning"><i class="fas fa-exclamation-triangle"></i>&nbsp;cestinato</div>
                                    </small>
                                </ng-container>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="record.contracts">
                                {{ record.type | uppercase }}
                                <ng-container *ngIf="record.contracts.length>0">
                                    <ng-container *ngFor="let c of record.contracts">
                                        <small>
                                            <div class="alert alert-info p-1 text-center">
                                                <i  (click)="openContract(c);" title="Visualizza contratto" class="fa-file-signature fas mr-2 pointer"></i>
                                                Contratto {{c.type}} "{{c.description}}"<br>
                                                <span class="badge">Scadenza {{c.end | date:"dd-MM-Y"}}</span>
                                            </div>
                                        </small>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </td>
                        <td>
                            <button type="button" class="btn btn-danger" (click)="remove(i)"><i class="fa fa-times"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <ng-container *ngIf="list.length>0">
                <button type="button" class="btn btn-block btn-lg btn-success mt-3" (click)="createDocumentInventory()">Crea documento rientro magazzino</button>
            </ng-container>
            </div>
        </div>
    </div>
</div>